import { Input } from 'antd';
import React from 'react';

interface IProps {
    minLength?: number;
    maxLength?: number;
    placeholder?: string;
    field?: any;
    onBlur?: () => void;
    onFocus?: () => void;
    className?: string;
    min?: number;
    max?: number;
    defaultValue?: number;
    type?: string;
    onKeyDown?: (e: any) => void;
    refInput?: any;
    id?: string;
    disabled?: boolean;
    // onChange?: (e: any) => void;
}

const InputOnlyNumber: React.FC<IProps> = ({
    field,
    minLength,
    maxLength,
    placeholder,
    onBlur,
    onFocus,
    className,
    min,
    max,
    defaultValue,
    type,
    onKeyDown,
    refInput = null,
    id,
    disabled,
    // onChange,
}) => {
    const onKeyPress = (e: React.KeyboardEvent) => {
        const specialCharRegex = new RegExp('[0-9]');
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);

        if (!specialCharRegex.test(pressedKey) || pressedKey === ' ') {
            e.preventDefault();
            return;
        }

        const { value } = e?.target as any;

        if (maxLength && value.length >= maxLength) {
            e.preventDefault();
            return;
        }
    };

    const disabledCopyPaste = (e: React.KeyboardEvent) => {
        e.preventDefault();
        return false;
    };

    return (
        <Input
            className={className}
            onBlur={onBlur}
            onFocus={() => {
                if (onFocus) onFocus();
            }}
            minLength={minLength}
            maxLength={maxLength}
            min={min}
            max={max}
            placeholder={placeholder}
            defaultValue={defaultValue}
            controls={false}
            onKeyPress={onKeyPress}
            inputMode="none"
            pattern="[0-9]*"
            type={type}
            disabled={disabled}
            onPaste={disabledCopyPaste}
            {...field}
            onKeyDown={(e: any) => {
                if (onKeyDown) onKeyDown(e);
            }}
            id={id}
            ref={refInput}
        />
    );
};

export default React.memo(InputOnlyNumber);
